import { linkSchema, linkAttr } from '@milkdown/preset-commonmark';
import { normalizeUrl } from '../../../util/link';
/**
 * Extended link schema that:
 * 1. Normalizes URLs (adds https:// if no protocol)
 * 2. Opens links in new tabs with target="_blank"
 * 3. Adds rel="noopener noreferrer" for security
 */
export const customLinkSchema = linkSchema.extendSchema(prevSchema => ctx => {
    const baseSchema = prevSchema(ctx);
    return {
        ...baseSchema,
        attrs: {
            ...baseSchema.attrs,
            href: {
                default: null,
                validate: 'string|null',
            },
            title: {
                default: null,
                validate: 'string|null',
            },
            target: {
                default: '_blank',
            },
            rel: {
                default: 'noopener noreferrer',
            },
        },
        parseDOM: [
            {
                tag: 'a[href]',
                getAttrs: (dom) => {
                    if (typeof dom === 'string') {
                        return false;
                    }
                    const href = dom.getAttribute('href');
                    const title = dom.getAttribute('title');
                    const target = dom.getAttribute('target');
                    const rel = dom.getAttribute('rel');
                    return {
                        href: href ? normalizeUrl(href) : null,
                        title,
                        target: target || '_blank',
                        rel: rel || 'noopener noreferrer',
                    };
                },
            },
        ],
        toDOM: node => {
            const { href, title, target, rel } = node.attrs;
            const normalizedHref = href ? normalizeUrl(href) : '';
            return [
                'a',
                {
                    ...ctx.get(linkAttr.key)(node),
                    href: normalizedHref,
                    title: title || undefined,
                    target: target || '_blank',
                    rel: rel || 'noopener noreferrer',
                },
                0,
            ];
        },
        inclusive: false,
    };
});
//# sourceMappingURL=custom_link_schema.js.map